import { Injectable, inject } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { ITask } from 'shared';

import { SoundService } from '../sound.service';
import { TaskAssignmentBaseSocketEventHandler } from './task-assignment-base.se-handler';

interface TaskAssignedSocketEvent {
    eventDtoType: 'TaskAssigned';
    assignedById: string;
    previousAssigneeId: string;
    task: ITask;
}

@Injectable({ providedIn: 'root' })
export class TaskAssignedSocketEventHandler extends TaskAssignmentBaseSocketEventHandler<TaskAssignedSocketEvent> {
    private readonly soundService = inject(SoundService);

    protected eventDtoType(): string {
        return 'TaskAssigned';
    }

    protected handleEvent = async (event: TaskAssignedSocketEvent): Promise<void> => {
        const hasPermission = await this.ensureLocalState(event);

        // Play sound effect if needed
        if (hasPermission) {
            this.appState.user.distinctStream
                .pipe(
                    take(1),
                    filter((user) => event.task.assigneeId === user.id),
                    filter((user) => event.assignedById !== user.id)
                )
                .subscribe((_) => this.soundService.playSound('external_assign.mp3'));
        }
    };
}
